import { Dropdown, Label } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledLabel = styled(Label)`
border-radius: 50% !important;
font-size: 10px !important;
color: red !important;
margin: 0 -1.3em 0 -1.7em !important;
`
export const StyledDropdownMenu = styled(Dropdown.Menu)`
 width: 300px !imporatant;
 position: relative;
 .header {
  display: flex;
  align-items: center;
  justify-content: space-between !important;
 }
 .hasUrl {
  pointer: cursor !important;
 }
 .titleItem { 
  display: flex;
  align-items: center;
  gap: 3px;
  .date {
   font-size: .85714286em !important;
   color: rgba(0,0,0,.4);
  }
 }
 .descriptionItem {
  font-style: italic;
  margin-top: 5px;
  margin-left: 30px;
  width: 250px;
  max-width: 250px;
  white-space: pre-wrap;
 }
`
